import { slugify } from "@/libs/utils";

type Props = {
  state: string;
  shortname: string;
};

const VehicleTransactionInfoSection = ({ state, shortname }: Props) => {
  const stateKey = (state ?? "").toLowerCase().replace(" ", "-");
  return (
    <section>
      {state != undefined && state != "" && (
        <div className="w-full px-4 md:px-0">
          <p className="text-xl sm:text-3xl font-bold opacity-90 py-8">
            {state} vehicle transaction information
          </p>
          <ul className="w-full text-base sm:text-2xl text-[#35acce] font-semibold space-y-6 opacity-90">
            <li>
              <a
                href={`/blog/how-to-transfer-a-car-title-in-${stateKey}`}
                className="underline"
              >
                How to transfer a car title in {state}
              </a>
            </li>
            <li>
              <a
                href={`/blog/what-paperwork-do-i-need-to-sell-my-car-in-${stateKey}`}
                className="underline"
              >
                What paperwork do I need in {state}?
              </a>
            </li>
            <li>
              <a
                href={`/blog/how-much-are-license-plates-in-${stateKey}`}
                className="underline"
              >
                How much do {state} license plates cost?
              </a>
            </li>
            <li>
              <a
                href={`/blog/how-to-buy-a-used-car-in-${stateKey}`}
                className="underline"
              >
                Buying a used car in {state}: a guide
              </a>
            </li>
            <li>
              <a
                href={`/blog/used-car-sales-taxes-in-${stateKey}`}
                className="underline"
              >
                How much is {state} used car sales tax?
              </a>
            </li>
            <li>
              <a
                href={`/blog/should-i-remove-license-plates-when-selling-a-car-in-${stateKey}`}
                className="underline"
              >
                Does seller remove plates in {state}?
              </a>
            </li>
          </ul>
        </div>
      )}
    </section>
  );
};

export default VehicleTransactionInfoSection;
